import { NAME as APP_NAME } from 'constants';

export const NAME = `${APP_NAME}/STOCK_UNIT`;

export const REDUCER_NAME = 'stockUnit';
export const CREATE_FORM_NAME = 'newStockUnit';
export const CREATE_ENDPOINT = `${SHIPPING_EDGE}/api/sku`;

export const DEFAULT_CONFIG_VALUE = {
  layers: 0,
  uomPerLayers: 0,
  uomPerPallet: 0,
};
